/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { connect } from 'react-redux'
import { getSelfUser } from '@sportninja/common/selectors/users'
import { useMemo, useRef, useState } from 'react'
import PostInput from '../PostInput'
import FeedPage from '../FeedPage'
import FeedPostCreateModal from '../FeedPostCreateModal'

interface EntityFeedProps {
  entity: any
  entityType: 'team' | 'schedule' | 'organization'
  entityId: string
  refreshKey?: number
  canPost?: boolean
  canTargetAudience?: boolean
  user?: any
}

const EntityFeed = ({
  entity,
  entityType,
  entityId,
  canPost = false,
  canTargetAudience = false,
  user,
}: EntityFeedProps) => {
  const [permission, setPermission] = useState<Record<string, any>>({})
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [postToEdit, setPostToEdit] = useState<any>(null)
  const [isLoadingFeed, setIsLoadingFeed] = useState(false)
  const refreshNewFeed = useRef<(() => void) | null>(null)

  const shouldDisplayPostCreate = useMemo(() => {
    return (
      permission?.[entityId]?.update || permission?.[entityId]?.post || canPost
    )
  }, [canPost, entityId, permission])

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 100%;
        max-width: 650px;
        margin: 0 auto;
        margin-top: 16px;
        @media (max-width: 768px) {
          padding-left: 16px;
          padding-right: 16px;
        }
      `}
    >
      <FeedPostCreateModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        entityType={entityType}
        entityId={entityId}
        refreshNewFeed={refreshNewFeed.current || (() => {})}
        postToEdit={postToEdit}
        setPostToEdit={setPostToEdit}
        entity={entity}
        canTargetAudience={canTargetAudience}
      />

      {shouldDisplayPostCreate && !isLoadingFeed && (
        <PostInput
          onInputClick={() => setIsModalOpen(true)}
          avatarUrl={user?.imageId}
        />
      )}

      <FeedPage
        entityId={entityId}
        entityType={entityType}
        canEdit={permission?.[entityId]?.update}
        canDelete={permission?.[entityId]?.update}
        avatarUrl={user?.imageId}
        refreshNewFeed={refreshNewFeed}
        setPermission={setPermission}
        user={user}
        isEntityFeed={true}
        setPostToEdit={setPostToEdit}
        setModalOpen={setIsModalOpen}
        setIsLoadingFeed={setIsLoadingFeed}
        setIsModalOpen={setIsModalOpen}
      />
    </div>
  )
}

const mapStateToProps = (state: any) => ({
  user: getSelfUser(state),
})

export default connect(mapStateToProps)(EntityFeed)
